import BordOneToneIcon from '../../../../../../../../components/NudosComponents/BordOneToneIcon/BordOneToneIcon';
import useStockOrdersModuleState from '../../../../../../../../state/useStockOrdersModuleState';
import { CREAT_NEW_ORDER_STOCK_STEPS } from '../../../../../../../../types/orders';
import './PrevWarehouseSelectBanner.scss';

const PrevWarehouseSelectBanner = () => {
  const { searchWarehouse, setCurrentStep, setSearchWarehouse, setSelectedProducts, setSelectedProvider } =
    useStockOrdersModuleState();
  

  const handleGoBack = () => {
    setCurrentStep(CREAT_NEW_ORDER_STOCK_STEPS.SELECT_WAREHOUSE);
    setSearchWarehouse({ name: '', id: 0, flag: '', currencyCode: '' });
    setSelectedProducts([]);
    setSelectedProvider(null);
  };

  return (
    <div className="prevWarehouseSelectBanner">
      <div className="warehouseSelectedContainer">
        <div className="wrapperIcon">
          <BordOneToneIcon variant="stockOrder" standardSize={16} />
        </div>
        <div>
          <div className="warehouseSelectedText">Bodega Seleccionada</div>
          <div className="warehouseSelectedFlagContainer">
            <img src={searchWarehouse?.flag} alt="flag" className="w-4 h-4" />
            <div className="text-nudos-text-color">{searchWarehouse?.name}</div>
          </div>
        </div>
      </div>
      <div
        className="changeWarehouseButton"
        onClick={handleGoBack}
      >
        <div className="changeWarehouseText">Cambiar de bodega</div>
        <BordOneToneIcon variant="arrorLoop" standardSize={8} />
      </div>
    </div>
  );
};

export default PrevWarehouseSelectBanner;
